import { useEffect, useState } from "react";
import { MapPin, Plus } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Cities() {
  const { user } = useAuth();
  const [cities, setCities] = useState([]);
  const [form, setForm] = useState({ name: "", zips: "" });
  const isAdmin = user?.role === "admin";

  const load = () => api.get("/cities").then((r) => setCities(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/cities", { name: form.name, zip_codes: form.zips.split(",").map((z) => z.trim()).filter(Boolean) });
      toast.success("City added");
      setForm({ name: "", zips: "" });
      load();
    } catch (e2) { toast.error(errMsg(e2)); }
  };

  return (
    <div data-testid="cities-page" className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[#1B2A4A]">Broward Cities</h1>
        <p className="text-sm text-[#475569] mt-1">{cities.length} municipalities — businesses must be registered within Broward County</p>
      </div>

      {isAdmin && (
        <form onSubmit={add} className="bg-white border border-[#E2E8F0] rounded-xl p-5 flex items-end gap-3 flex-wrap">
          <div className="space-y-1.5">
            <Label>City Name</Label>
            <Input data-testid="new-city-name" required value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. Lauderdale-by-the-Sea" className="w-64" />
          </div>
          <div className="space-y-1.5">
            <Label>Zip Codes (comma separated)</Label>
            <Input data-testid="new-city-zips" value={form.zips} onChange={(e) => setForm((f) => ({ ...f, zips: e.target.value }))} placeholder="33308, 33062" className="w-64" />
          </div>
          <Button data-testid="add-city-button" type="submit" className="bg-[#2E7BD6] hover:bg-[#2568b8] text-white">
            <Plus size={15} className="mr-1.5" /> Add City
          </Button>
        </form>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="cities-grid">
        {cities.map((c) => (
          <div key={c.id} data-testid={`city-card-${c.slug}`} className="bg-white border border-[#E2E8F0] rounded-xl p-4 hover:border-[#2E7BD6]/40 transition-colors">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-[#2E7BD6]/10 flex items-center justify-center">
                <MapPin size={15} className="text-[#2E7BD6]" />
              </div>
              <span className="font-semibold text-[#0F172A] text-sm">{c.name}</span>
            </div>
            {c.zip_codes?.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-3">
                {c.zip_codes.map((z) => (
                  <span key={z} className="text-[10px] font-medium text-[#475569] bg-[#F5F7FA] border border-[#E2E8F0] rounded px-1.5 py-0.5">{z}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
